module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedItalic.6ad62a7.eot";